import { ExclamationCircleIcon } from "@heroicons/react/solid";
import * as Sentry from "@sentry/nextjs";
import { useTranslation } from "next-i18next";

import { InformationContainerLayout } from "./InformationContainerLayout";
import { InformationCoreProps } from "./type";

type ErrorStateProps = {
  // apollo error and trpc error is not supposed to put here
  // since their errors has been sent to sentry in the client global setting level
  error?: any;
} & InformationCoreProps;

export const ErrorState: React.FC<ErrorStateProps> = (props) => {
  const { t, ready } = useTranslation("common");
  const { position, flexDirection, message, error } = props;

  if (!ready) return null;

  return (
    <InformationContainerLayout
      position={position}
      flexDirection={flexDirection}
    >
      <ExclamationCircleIcon className="text-[100px] max-w-100" />
      <h5>{message ?? t("common:information.error")}</h5>
    </InformationContainerLayout>
  );
};
